import { useEffect } from 'react'
import { usePageTitle } from 'src/hooks'

import SignIn from 'src/components/organisms/signin'

export default function SignInPage({ title }: { title: string }) {
  usePageTitle(title)

  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18nextLng')

    localStorage.clear()

    if (currentLanguage) {
      localStorage.setItem('i18nextLng', currentLanguage)
    }
  }, [])

  return <SignIn />
}
